import axios from 'axios';

// Create a separate axios instance for the time-keep API
const timekeepClient = axios.create({
  baseURL: process.env.REACT_APP_TIMEKEEP_BASE_URL || 'http://localhost:7001/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
timekeepClient.interceptors.request.use(
  (config) => {
    // Add any authentication headers if needed
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
timekeepClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle common errors
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default timekeepClient;
